export const ADD_STUDENTS = 'STUDENTS.ADD_STUDENTS';
export const ADD_STUDENTS_START = 'STUDENTS.ADD_STUDENTS_START';
export const ADD_STUDENTS_FAIL = 'STUDENTS.ADD_STUDENTS_FAIL';
export const ADD_STUDENTS_SUCCESS = 'STUDENTS.ADD_STUDENTS_SUCCESS';

export const GET_STUDENTS = 'STUDENTS.GET_STUDENTS';
export const GET_STUDENTS_START = 'STUDENTS.GET_STUDENTS.START';
export const GET_STUDENTS_FAIL = 'STUDENTS.GET_STUDENTS.FAIL';
export const GET_STUDENTS_SUCCESS = 'STUDENTS.GET_STUDENTS.SUCCESS';
